import _ from "lodash";

import IColumn from "models/IColumn";
import { TYPE_OPTIONS, STATUS_OPTIONS } from "./constants";

export const getColumns = (local = "nl"): IColumn[] => [
  {
    key: "checkbox",
    isSortable: false,
    fixedWidth: 52,
    visible: true,
    notRowClick: true
  },
  {
    title: "DATE",
    fixedWidth: 164,
    key: "Date",
    type: "date",
    visible: true
  },
  {
    title: `TITLE`,
    key: `Title_${local}`,
    visible: true
  },
  {
    title: "STATUS",
    key: "Status",
    visible: true,
    render: ({ Status }) =>
      _.get(_.find(STATUS_OPTIONS, ["value", Status]), "label", "-")
  },
  {
    title: `TEXT_TEASER`,
    key: `Teaser_${local}`,
    visible: false
  },
  {
    title: "TYPE",
    key: "Type",
    visible: true,
    render: ({ Type }) =>
      _.get(_.find(TYPE_OPTIONS, ["value", Type]), "label", "-")
  }
];
